// function urlPfad() {
//   if (process.env.NODE_ENV === "production") return "/api";
//   if (process.env.NODE_ENV === "staging") return "/api";
//   return window.webpackHotUpdate ? "http://10.12.12.16:8080/ords/oe_apx_ext/mipo-api";
// }

export default {
  data: {
    config: {
      appBaseURL: "/",
      apiBaseURL: "/api",
      objektStammdaten: {
        top_art: {
          iconDefault: "mdi-home",
          iconMapping: {
            B: "mdi-office-building",
            EH: "mdi-home",
            GA: "mdi-garage",
            GW: "mdi-google-my-business",
            L: "mdi-warehouse",
            PA: "mdi-car",
            W: "mdi-home-city",
          },
        },
      },
      objektDokumente: {
        dokument_art: {
          iconDefault: "mdi-file-document",
          iconMapping: {
            "Mietvertrag / Vereinbarung": "mdi-file-document-edit",
            Übergabeprotokoll: "mdi-format-list-checks",
            Eigentümerfreigabe: "mdi-account-check",
            Kautionszahlungsbeleg: "mdi-account-cash",
          },
        },
      },
    },
  },
};
